export class TrendingTitlesFilter {
  public filterName: string;
  public daysOut?: number;
  public monthsOut?: number;

  constructor(filterName: string, daysOut?: number, monthsOut?: number) {
    this.filterName = filterName;
    this.daysOut = daysOut;
    this.monthsOut = monthsOut;
  }
}
